import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["users--fields", "users--account"]

  static targets = ["toggle", "fields", "destroyFlag", "address", "city", "postalCode", "email", "country", "province"]

  connect() {
    this.#updateVisibility()
  }

  toggle() {
    this.#updateVisibility()

    if (this.toggleTarget.checked) {
      this.#prefill()
    }
  }

  #updateVisibility() {
    const show = this.toggleTarget.checked

    this.fieldsTarget.classList.toggle("d-none", !show)
    this.fieldsTarget.disabled = !show
    this.destroyFlagTarget.value = show ? "0" : "1"
  }

  #prefill() {
    this.#fill(this.addressTarget, this.usersFieldsOutlet.physicalAddress)
    this.#fill(this.cityTarget, this.usersFieldsOutlet.city)
    this.#fill(this.postalCodeTarget, this.usersFieldsOutlet.postalCode)
    this.#fill(this.emailTarget, this.usersAccountOutlet.email)

    this.#prefillCountryAndProvince()
  }

  #prefillCountryAndProvince() {
    const country = this.usersFieldsOutlet.country
    if (!country || this.countryTarget.value) return

    this.countryTarget.value = country
    this.countryTarget.dispatchEvent(new Event("change"))

    this.#fill(this.#enabledProvinceTarget, this.usersFieldsOutlet.province)
  }

  #fill(field, value) {
    if (field && value && !field.value) field.value = value
  }

  get #enabledProvinceTarget() {
    return this.provinceTargets.find(target => !target.disabled)
  }
}
